import { render } from "./ValidatePhoneNumber.vue?vue&type=template&id=e4ab5b72&scoped=true"
import script from "./ValidatePhoneNumber.vue?vue&type=script&lang=js"
export * from "./ValidatePhoneNumber.vue?vue&type=script&lang=js"

import "./ValidatePhoneNumber.vue?vue&type=style&index=0&id=e4ab5b72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4ab5b72"]])

export default __exports__